import { z } from 'zod'

export const CRM_BINDING_CONTRACT_VERSION = '1.0.0' as const

const crmBindingEnvelope = z.object({
  contract_version: z.literal(CRM_BINDING_CONTRACT_VERSION),
}).passthrough()

export const crmBindingFindLeadResponseSchema = crmBindingEnvelope
export const crmBindingListLeadsResponseSchema = crmBindingEnvelope
export const crmBindingReadinessResponseSchema = crmBindingEnvelope

export type CrmBindingFindLeadResponse = z.infer<typeof crmBindingFindLeadResponseSchema>
export type CrmBindingListLeadsResponse = z.infer<typeof crmBindingListLeadsResponseSchema>
export type CrmBindingReadinessResponse = z.infer<typeof crmBindingReadinessResponseSchema>
